import script from "./ExportMenu.vue?vue&type=script&lang=js"
export * from "./ExportMenu.vue?vue&type=script&lang=js"

export default script